"use client";

import { EnhancedTimeline } from "@/features/timeline/components/EnhancedTimeline";
import { AISummary } from "@/components/ai/ai-summary";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

import type { Contact } from "@/lib/types/database";
import { CONTACT_TIMELINE_SUMMARY_OPTIONS } from "@/lib/domain/crm-entity-relationships";

interface ContactTimelineProps {
  email: string;
  client?: Contact;
  /**
   * When false, only the communication timeline card is rendered (no AI summary block).
   * Use when the summary is shown earlier on the same screen (e.g. contact Details tab).
   */
  showAISummary?: boolean;
}

export const ContactTimeline = ({
  email,
  client,
  showAISummary = true,
}: ContactTimelineProps) => {
  return (
    <div className="space-y-6">
      {/* AI Summary Section */}
      {showAISummary && client?.id && (
        <div className="mb-6">
          <AISummary
            contactId={client.id}
            summaryType="timeline"
            options={{ ...CONTACT_TIMELINE_SUMMARY_OPTIONS }}
            showMetadata={true}
            showRefreshButton={true}
            className="mb-4"
          />
        </div>
      )}

      {/* Timeline Section. Tighter padding on mobile so the timeline content
          uses the full ~390px width instead of being squeezed by p-6 chrome. */}
      <Card>
        <CardHeader className="p-3 pb-0 md:p-6 md:pb-0">
          <CardTitle>Communication history</CardTitle>
        </CardHeader>
        <CardContent className="p-3 pt-3 md:p-6 md:pt-6">
          <EnhancedTimeline email={email} client={client} className="h-full" />
        </CardContent>
      </Card>
    </div>
  );
};
